import { type MRT_ColumnDef } from 'material-react-table';
import { useMemo } from 'react';
import { Chip } from '@mui/material';
import { emptyCellOneLevel } from '@/shared';
import {
  firmaEstadoColor,
  firmaEstadoLabel,
  type FirmaAdendumRow,
} from '../utils';

export const useColumnsFirmaAdendum = () => {
  const columnsFirmaAdendum = useMemo<MRT_ColumnDef<FirmaAdendumRow>[]>(
    () => [
      {
        accessorKey: 'noTramite',
        header: 'N° TRÁMITE',
        size: 130,
        Cell: ({ row }) => emptyCellOneLevel(row, 'noTramite'),
      },
      {
        accessorKey: 'cedula',
        header: 'CÉDULA',
        size: 140,
        Cell: ({ row }) => emptyCellOneLevel(row, 'cedula'),
      },
      {
        accessorKey: 'modoFirmantes',
        header: 'MODO FIRMANTES',
        size: 150,
        Cell: ({ row }) => emptyCellOneLevel(row, 'modoFirmantes'),
      },
      {
        accessorKey: 'estado',
        header: 'ESTADO',
        size: 190,
        Cell: ({ row }) => {
          const raw = (row.original as FirmaAdendumRow).estado;
          return (
            <Chip
              size="small"
              label={firmaEstadoLabel(raw)}
              color={firmaEstadoColor(raw)}
              variant="outlined"
            />
          );
        },
      },
      {
        accessorKey: 'fechaCreacion',
        header: 'FECHA CREACIÓN',
        size: 170,
        Cell: ({ row }) => emptyCellOneLevel(row, 'fechaCreacion'),
      },
      {
        accessorKey: 'fechaActualizacion',
        header: 'FECHA ACTUALIZACIÓN',
        size: 170,
        Cell: ({ row }) => emptyCellOneLevel(row, 'fechaActualizacion'),
      },
    ],
    []
  );

  return {
    columnsFirmaAdendum,
  };
};
